import { isN } from "./tools";

// todo 这块可以重新整理

/*
1.localStorage特定于页面的协议，不是同一域名，不能访问。
2.有长度限制，5M左右，不同浏览器大小会有不同。
3.生命周期是永久的，但是数据实际是存在浏览器的文件夹下，可能卸载浏览器就会删除。
4.浏览器可以设置是否可以访问数据，如果设置不允许会访问失败。
5.兼容IE8以上浏览器
6.只能存储字符串类型，需要转成字符串存储。
----------------------------------------------
1.先判断浏览器是否支持localStorage，通过if(!window.localStorage) return;
2.单词太长，不方便书写，可以利用 var storage=window.localStorage;
3.字符串和原始类型需要通过JSON.stringfy转字符串，通过JSON.parse转成对象
4.通过封装方法实现来回转化
**/

export function  setKey(key, value) {
    localStorage.setItem(key, value);
  }

 export function setKeyJsonStr(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  }
  //key若是json数据，只更新其中一部分
 export function updateKeyJson(key:string, subKey:string, value:any) {
    let json = {}
    try{
      json = JSON.parse(localStorage.getItem(key))
    }catch(e){
      ;
    }
    if(!json) json={};
    if(isN(value)){//如果是null等，直接删除而不是存成字符串null
      delete json[subKey];
    }else{
      json[subKey] = value;//不用存字符，直接存值JSON.stringify(value);
    }
    
    setKeyJsonStr(key, json)
  }

  //key若是json数据，只取出其中一部分
 export function getsubKey(key:string, subKey:string) {
    let v = getKeyJson(key);
    if(v){
      return v[subKey];
    }
    return v;
  }


 export function getKeyStr(key) {
    return localStorage.getItem(key);
  }
 export function getKeyNum(key) {
    let kv = localStorage.getItem(key);
    if(kv === null || kv === undefined)return kv;
    return Number(kv);
  }
  
 export function getKeyJson(key:string) {
    let item = localStorage.getItem(key);
    if(item){
      try{
        return JSON.parse(item);
      }catch(e){
        //异常了返回空的JSON
        return {};
      }
    }
    return item;
  }

 export function removeKey(key:string) {
    localStorage.removeItem(key);
  }

export function removeKeys(keys:string[]) {
    for(let key of keys){
      localStorage.removeItem(key);
    }
  }

  /**获取所有的key*/
export function  keys(){
    //let size = localStorage.length;
    let arr = [];
    for (let i = 0, j= localStorage.length; i<j; i++) {
      arr[i] = localStorage.key(i);
    }
    return arr;
  }
  /**实现某些用户的特定缓存的清理
   * 
   * jsonSubKey表示某个起始的项中，
  */
export function  clear(prefix:string/*, jsonSubKey:string*/) {
    if(prefix === undefined || prefix === null || prefix.length === 0){
        localStorage.clear();
    }else{
      let key:string;
      for (let i = 0, j= localStorage.length; i<j; i++) {
        key = localStorage.key(i);
        try{
          if(key !== null && key !== undefined){
            if(key.startsWith(prefix)){
              localStorage.removeItem(key);
            }
          }
        }catch(e){//之前有异常未捕获
          console.error(e);
        }
      }
    }
  }



